<template>
  <section class="mt-10 p-8 md:p-16 rounded-md" v-bind="$attrs">
    <div class="max-w-7xl mx-auto">
      <div
        class="flex flex-col md:flex-row gap-4"
        :class="`${props.reverse ? 'md:flex-row-reverse' : ''}`"
      >
        <div class="w-full flex items-center justify-center" v-if="props.imageUrl">
          <NuxtImg
            :src="props.imageUrl"
            :alt="props.imageAlt"
            width="400"
            height="400"
          />
        </div>
        <div class="w-full flex flex-col justify-center">
          <h2 class="text-xl md:text-3xl font-bold text-orange-500">
            {{ props.title }}
          </h2>
          <div
            class="page-sticks flex flex-row flex-nowrap items-center mt-2 md:mt-4"
          >
            <div></div>
            <div></div>
          </div>
          <template v-for="text in props.texts" :key="text">
            <p class="text-xs md:text-sm text-slate-600 mt-4" v-html="text"></p>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    imageUrl?: string
    imageAlt?: string
    title?: string
    texts?: string[]
    reverse?: boolean
  }>(),
  {
    imageUrl: '',
    imageAlt: '',
    title: '',
    texts: () => [],
    reverse: false,
  },
)
</script>

<style scoped>
.page-sticks {
  div:nth-child(1) {
    width: 60px;
    height: 3px;
    background-color: #f97316;
  }
  div:nth-child(2) {
    width: 40px;
    height: 2px;
    background-color: #f97316;
    opacity: 0.5;
  }
}
</style>
